import { computed, defineComponent, provide, reactive, ref, toRefs } from 'vue'
import { getComponentNamespace, getNamespace } from '../../../utils/global-config'
import { timelineProps } from './props'
import { timelineInjectionKey } from './context'
const childrenName = getComponentNamespace('TimelineItem')

export default defineComponent({
  name: getComponentNamespace('Timeline'),
  components: {},
  props: timelineProps,
  emits: ['update:current', 'change'],
  setup(props, { slots }) {
    // 定义组件命名
    const ns = getNamespace('timeline')
    // 组件class
    const cls = computed(() => [ns, props.reverse && `is-reverse`])
    // 顺序反转
    const { reverse: reverseRef, lineType: lineTypeRef } = toRefs(props)
    const componentCount = ref(0)
    /**
     * @description 获取Timeline真实子组件
     */
    const getChildren = (slotsDefault: any) => {
      if (Array.isArray(slotsDefault) && slotsDefault.length > 0) {
        return slotsDefault.filter((item) => {
          if (
            Array.isArray(item.children) &&
            item.children.length > 0 &&
            typeof item['type'] === 'symbol'
          ) {
            item.children = getChildren(item.children)
            return item.children.length > 0 ? item : null
          }
          if ((item?.type as any)?.name === childrenName) {
            return item
          }
        })
      }
      return []
    }
    // 获取数组有多少个叶子节点
    const getLeafCount = (children: any[]) => {
      let count = 0
      children.forEach((item) => {
        if (Array.isArray(item.children)) {
          count += getLeafCount(item.children)
        } else {
          count += 1
        }
      })
      return count
    }

    const components = (slotsDefault: any) => {
      const items = getChildren(slotsDefault)
      componentCount.value = getLeafCount(items)
      return items
    }
    /**
     * @description 响应式传递
     */
    const provideContext = reactive({
      reverse: reverseRef,
      parentCls: ns,
      count: componentCount,
      lineType: lineTypeRef
    })
    provide(timelineInjectionKey, provideContext)
    return () => {
      return <div class={cls.value}>{components(slots.default?.())}</div>
    }
  }
})
